import { combineReducers } from '@reduxjs/toolkit'

import { reducer as group } from './group_management/slice'
import { reducer as invitations } from './invitation_memberships/slice'
import { reducer as migrations } from './migration_memberships/slice'
import { reducer as users } from './user_memberships/slice'

export const reducer = combineReducers({ group, users, invitations, migrations })
